import React from 'react';
import './LowboyTimesheet.scss';
import {
    Card,
    CardHeader,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    ModalHeader,
} from 'reactstrap';
import LowboyRequestCardBody from '../lowboyDispatch/LowboyRequestCardBody';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import { FormLabel } from '../common/forms/FormElements';
import cls from 'classnames';
import AdjustmentDetail from '../crewTimesheet/AdjustmentDetail';

export default class LowboyTimesheetDetailCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };
    }

    onNotesChange = (e) => {
        const notes = e && e.target ? e.target.value : null;

        const lowboyTimesheetDetail = this.getLowboyTimesheetDetail();

        lowboyTimesheetDetail.notes = notes;

        const { lowboyTimesheet, onTimesheetMutated } = this.props;

        onTimesheetMutated(lowboyTimesheet);
    };

    onAdjustmentNotesChange = (e) => {
        const adjustmentNotes = e && e.target ? e.target.value : null;

        const lowboyTimesheetDetail = this.getLowboyTimesheetDetail();

        lowboyTimesheetDetail.adjustmentNotes = adjustmentNotes;

        const { lowboyTimesheet, onTimesheetMutated } = this.props;

        onTimesheetMutated(lowboyTimesheet);
    };

    getLowboyTimesheetDetail = () => {
        const { lowboyAssignmentId, lowboyTimesheet } = this.props;

        return lowboyTimesheet.lowboyTimesheetContracts
            .flatMap((ltc) => ltc.lowboyTimesheetDetails)
            .find((ltd) => ltd.lowboyAssignmentId == lowboyAssignmentId);
    };

    toggleModal = () => {
        const { isReadOnly } = this.props;

        const lowboyTimesheetDetail = this.getLowboyTimesheetDetail();

        if (
            isReadOnly &&
            !lowboyTimesheetDetail.notes &&
            !lowboyTimesheetDetail.adjustmentNotes
        ) {
            return;
        }

        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    render() {
        const {
            loading,
            lowboyAssignments,
            contractId,
            equipments,
            equipmentTypes,
            lowboyAssignmentId,
            isReadOnly,
            isAdmin,
            modifyingUsers,
        } = this.props;

        const { showModal } = this.state;

        if (loading || !contractId) {
            return null;
        }

        const lowboyAssignment = lowboyAssignments.find(
            (la) => la.id == lowboyAssignmentId
        );

        const equipment = equipments.find(
            (eq) => eq.id == lowboyAssignment.equipmentId
        );

        const equipmentType = equipmentTypes.find(
            (et) => et.id == lowboyAssignment.lowboyResource.equipmentTypeId
        );

        const lowboyTimesheetDetail = this.getLowboyTimesheetDetail();

        if (!lowboyTimesheetDetail) {
            return null;
        }

        const hasDetailNotes = Boolean(
            lowboyTimesheetDetail.notes || lowboyTimesheetDetail.adjustmentNotes
        );

        const displayNotes =
            lowboyTimesheetDetail.adjustmentNotes ??
            lowboyTimesheetDetail.notes;

        return (
            <div key={`ldouter-${lowboyAssignmentId}`} className="d-flex w-100">
                <Card
                    className={cls('mt-2', 'w-75', {
                        'detail-delivery-notes-card': hasDetailNotes,
                    })}
                    onClick={this.toggleModal}
                >
                    {hasDetailNotes && (
                        <CardHeader>
                            <FontAwesomeIcon
                                icon={faComment}
                                className="mr-1"
                            />{' '}
                            Notes:{' '}
                            <span className="text-overflow-ellipsis">
                                {displayNotes}
                            </span>{' '}
                            (Click to view)
                        </CardHeader>
                    )}
                    <LowboyRequestCardBody
                        lowboyAssignment={lowboyAssignment}
                        lowboyResource={lowboyAssignment.lowboyResource}
                        equipment={equipment}
                        equipmentType={equipmentType}
                        {...this.props}
                    />
                </Card>

                <Modal isOpen={showModal} toggle={this.toggleModal} size="xl">
                    <ModalHeader toggle={this.toggleModal}>
                        Additional Notes for {equipmentType.description} #
                        {equipment.identifier}
                    </ModalHeader>
                    <ModalBody>
                        <AdjustmentDetail
                            entity={lowboyTimesheetDetail}
                            modifyingUsers={modifyingUsers}
                            isAdmin={isAdmin}
                        />

                        <FormGroup>
                            <FormLabel text="Notes" />

                            <Input
                                type="textarea"
                                value={lowboyTimesheetDetail.notes || ''}
                                onChange={this.onNotesChange}
                                disabled={isReadOnly || isAdmin}
                                readOnly={isReadOnly || isAdmin}
                            />
                        </FormGroup>

                        {isAdmin && (
                            <FormGroup>
                                <FormLabel text="Adjustment Notes" />

                                <Input
                                    type="textarea"
                                    value={
                                        lowboyTimesheetDetail.adjustmentNotes ||
                                        ''
                                    }
                                    onChange={this.onAdjustmentNotesChange}
                                    disabled={isReadOnly}
                                    readOnly={isReadOnly}
                                />
                            </FormGroup>
                        )}
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
